import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";

import "./Footer.css";
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaYoutube, FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";
import { MyContext } from "../Context/MyContext";
import { SITE_LOGO, SITE_LOGO_ALT } from "../../Utils/imageUtils";

export default function Footer() {
  const { contact: contactRaw, brands } = useContext(MyContext);
  const contact = contactRaw || {};
  const socials = contact.socials || {};
  const office = contact.office || {};
  const map = contact.map || {};
  const navigate = useNavigate();

  return (
    <footer className="footer">
      <div className="footer-container">
        {/* LEFT - Logo & About */}
        <div className="footer-col">
          <div className="footer-logo" onClick={() => navigate("/")} role="button" tabIndex={0}>
            <img src={SITE_LOGO} alt={SITE_LOGO_ALT} className="footer-logo-img" />
          </div>
          <p className="footer-about">
            Cars Infinite is your trusted marketplace for buying and selling quality used cars.
            Explore top brands, verified listings, and the best deals near you.
          </p>

          <div className="footer-socials">
            <a href={socials.facebook || '#'}><FaFacebookF /></a>
            <a href={socials.twitter || '#'}><FaTwitter /></a>
            <a href={socials.linkedin || '#'}><FaLinkedinIn /></a>
            <a href={socials.youtube || '#'}><FaYoutube /></a>
          </div>
        </div>

        {/* MIDDLE - Pages */}
<div className="footer-col">
  <h4>Pages</h4>
  <div className="footer-pages">
    <div className="footer-link" onClick={() => navigate("/cars")}>
      Buy Car
    </div>
    <div className="footer-link" onClick={() => navigate("/upload-car")}>
      Sell Car
    </div>
    <div className="footer-link" onClick={() => navigate("/privacy-policy")}>
      Privacy Policy
    </div>
    <div className="footer-link" onClick={() => navigate("/contact")}>
      Contact
    </div>
  </div>
</div>

        {/* MIDDLE - Brands */}
        <div className="footer-col">
          <h4>Top Brands</h4>
          <div className="footer-brands">
            {brands.slice(0, 8).map((brand) => (
              <div key={brand.id} className="footer-brand">
                <img src={brand.image} alt={brand.name} />
                <span>{brand.name}</span>
              </div>
            ))}
          </div>
        </div>

        {/* RIGHT - Contact */}
        <div className="footer-col">
          <h4>Contact</h4>
          <div className="footer-contact">
            <p><FaMapMarkerAlt /> {office.address}</p>
            <p><FaPhoneAlt /> {contact.phone}</p>
            <p><FaEnvelope /> {contact.email}</p>
            <p className="footer-location">Location: {map.location}</p>
          </div>
        </div>
      </div>

      {/* Bottom */}
      <div className="footer-bottom">
        © {new Date().getFullYear()} Cars Infinite. All rights reserved.
      </div>
    </footer>
  );
}

